// Vehicle database with comprehensive EV models based on available assets
export const vehicleDatabase = {
  Tesla: {
    brandLogo: '/assets/carModelsLogo/Tesla.png',
    color: '#e53e3e',
    models: {
      'Model 3': {
        id: 'tesla-model-3',
        name: 'Model 3',
        image: '/assets/carModelssLogo/tesla_model_3.png',
        range: 358,
        batteryCapacity: 54,
        consumption: 0.15,
        fastChargingPower: 250,
        weight: 1611,
        type: 'Sedan',
        year: '2024',
        variants: [
          { name: 'Standard Range', range: 267, batteryCapacity: 50 },
          { name: 'Long Range', range: 358, batteryCapacity: 75 },
          { name: 'Performance', range: 315, batteryCapacity: 75 }
        ]
      },
      'Model Y': {
        id: 'tesla-model-y',
        name: 'Model Y',
        image: '/assets/carModelssLogo/tesla_model_y.png',
        range: 514,
        batteryCapacity: 75,
        consumption: 0.146,
        fastChargingPower: 250,
        weight: 1979,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Long Range', range: 514, batteryCapacity: 75 },
          { name: 'Performance', range: 488, batteryCapacity: 75 }
        ]
      }
    }
  },
  BMW: {
    brandLogo: '/assets/carModelsLogo/Bmw.png',
    color: '#0066cc',
    models: {
      'i3': {
        id: 'bmw-i3',
        name: 'i3',
        image: '/assets/carModelssLogo/bmw-i3.png',
        range: 153,
        batteryCapacity: 42.2,
        consumption: 0.16,
        fastChargingPower: 50,
        weight: 1365,
        type: 'Hatchback',
        year: '2022',
        variants: [
          { name: 'Base', range: 153, batteryCapacity: 42.2 }
        ]
      },
      'iX': {
        id: 'bmw-ix',
        name: 'iX',
        image: '/assets/carModelssLogo/bmw_ix.png',
        range: 630,
        batteryCapacity: 111.5,
        consumption: 0.177,
        fastChargingPower: 200,
        weight: 2585,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'xDrive40', range: 425, batteryCapacity: 76.6 },
          { name: 'xDrive50', range: 630, batteryCapacity: 111.5 }
        ]
      },
      'i7': {
        id: 'bmw-i7',
        name: 'i7',
        image: '/assets/carModelssLogo/bmw-i7-edrive50.png',
        range: 625,
        batteryCapacity: 101.7,
        consumption: 0.163,
        fastChargingPower: 195,
        weight: 2715,
        type: 'Sedan',
        year: '2024',
        variants: [
          { name: 'eDrive50', range: 625, batteryCapacity: 101.7 }
        ]
      }
    }
  },
  Audi: {
    brandLogo: '/assets/carModelsLogo/Audi.png',
    color: '#bb0a30',
    models: {
      'e-tron': {
        id: 'audi-e-tron',
        name: 'e-tron',
        image: '/assets/carModelssLogo/audi-e-tron.png',
        range: 222,
        batteryCapacity: 95,
        consumption: 0.24,
        fastChargingPower: 150,
        weight: 2565,
        type: 'SUV',
        year: '2023',
        variants: [
          { name: '50 quattro', range: 190, batteryCapacity: 71 },
          { name: '55 quattro', range: 222, batteryCapacity: 95 }
        ]
      },
      'Q8 e-tron': {
        id: 'audi-q8-etron',
        name: 'Q8 e-tron',
        image: '/assets/carModelssLogo/audi-q8-etron.png',
        range: 582,
        batteryCapacity: 114,
        consumption: 0.196,
        fastChargingPower: 170,
        weight: 2720,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: '50 quattro', range: 491, batteryCapacity: 89 },
          { name: '55 quattro', range: 582, batteryCapacity: 114 }
        ]
      }
    }
  },
  Hyundai: {
    brandLogo: '/assets/carModelsLogo/Hyundai.png',
    color: '#002c5f',
    models: {
      'Kona Electric': {
        id: 'hyundai-kona',
        name: 'Kona Electric',
        image: '/assets/carModelssLogo/hyundai_kona.png',
        range: 259,
        batteryCapacity: 64,
        consumption: 0.17,
        fastChargingPower: 77,
        weight: 1685,
        type: 'SUV',
        year: '2023',
        variants: [
          { name: 'Base', range: 259, batteryCapacity: 64 }
        ]
      },
      'IONIQ 5': {
        id: 'hyundai-ioniq5',
        name: 'IONIQ 5',
        image: '/assets/carModelssLogo/hyundai_ioniq5.png',
        range: 481,
        batteryCapacity: 77.4,
        consumption: 0.161,
        fastChargingPower: 235,
        weight: 2268,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Standard Range', range: 384, batteryCapacity: 58 },
          { name: 'Long Range', range: 481, batteryCapacity: 77.4 }
        ]
      },
      'Creta EV': {
        id: 'hyundai-creta-ev',
        name: 'Creta EV',
        image: '/assets/carModelssLogo/hyundai_creta_ev.png',
        range: 473,
        batteryCapacity: 51.4,
        consumption: 0.109,
        fastChargingPower: 85,
        weight: 1740,
        type: 'SUV',
        year: '2025',
        variants: [
          { name: 'Executive', range: 390, batteryCapacity: 42 },
          { name: 'Excellence', range: 473, batteryCapacity: 51.4 }
        ]
      }
    }
  },
  Kia: {
    brandLogo: '/assets/carModelsLogo/Kia.png',
    color: '#05141f',
    models: {
      'EV6': {
        id: 'kia-ev6',
        name: 'EV6',
        image: '/assets/carModelssLogo/kia-ev6.png',
        range: 528,
        batteryCapacity: 77.4,
        consumption: 0.147,
        fastChargingPower: 240,
        weight: 2185,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Standard Range', range: 394, batteryCapacity: 58 },
          { name: 'Long Range', range: 528, batteryCapacity: 77.4 },
          { name: 'GT', range: 424, batteryCapacity: 77.4 }
        ]
      },
      'EV9': {
        id: 'kia-ev9',
        name: 'EV9',
        image: '/assets/carModelssLogo/kia-ev9.png',
        range: 563,
        batteryCapacity: 99.8,
        consumption: 0.177,
        fastChargingPower: 240,
        weight: 2750,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Light', range: 563, batteryCapacity: 99.8 },
          { name: 'Wind', range: 505, batteryCapacity: 99.8 },
          { name: 'Land', range: 462, batteryCapacity: 99.8 }
        ]
      }
    }
  },
  Nissan: {
    brandLogo: '/assets/carModelsLogo/Nissan.png',
    color: '#c3002f',
    models: {
      'Leaf': {
        id: 'nissan-leaf',
        name: 'Leaf',
        image: '/assets/carModelssLogo/nissan-leaf.png',
        range: 149,
        batteryCapacity: 40,
        consumption: 0.18,
        fastChargingPower: 46,
        weight: 1580,
        type: 'Hatchback',
        year: '2023',
        variants: [
          { name: 'Base', range: 149, batteryCapacity: 40 },
          { name: 'e+', range: 226, batteryCapacity: 62 }
        ]
      }
    }
  },
  Tata: {
    brandLogo: '/assets/carModelsLogo/Tata.png',
    color: '#1e3a8a',
    models: {
      'Nexon EV': {
        id: 'tata-nexon-ev',
        name: 'Nexon EV',
        image: '/assets/carModelssLogo/tata_nexon_ev.png',
        range: 465,
        batteryCapacity: 40.5,
        consumption: 0.087,
        fastChargingPower: 60,
        weight: 1400,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Medium Range', range: 325, batteryCapacity: 30 },
          { name: 'Long Range', range: 465, batteryCapacity: 40.5 }
        ]
      },
      'Punch EV': {
        id: 'tata-punch-ev',
        name: 'Punch EV',
        image: '/assets/carModelssLogo/tata_punch_ev.png',
        range: 421,
        batteryCapacity: 35,
        consumption: 0.083,
        fastChargingPower: 50,
        weight: 1200,
        type: 'Hatchback',
        year: '2024',
        variants: [
          { name: 'Medium Range', range: 315, batteryCapacity: 25 },
          { name: 'Long Range', range: 421, batteryCapacity: 35 }
        ]
      },
      'Tiago EV': {
        id: 'tata-tiago-ev',
        name: 'Tiago EV',
        image: '/assets/carModelssLogo/tata_tiago_ev.png',
        range: 315,
        batteryCapacity: 24,
        consumption: 0.076,
        fastChargingPower: 33,
        weight: 1050,
        type: 'Hatchback',
        year: '2024',
        variants: [
          { name: 'Base', range: 315, batteryCapacity: 24 }
        ]
      },
      'Curvv EV': {
        id: 'tata-curvv-ev',
        name: 'Curvv EV',
        image: '/assets/carModelssLogo/tata_curvv_ev.png',
        range: 502,
        batteryCapacity: 55,
        consumption: 0.109,
        fastChargingPower: 70,
        weight: 1600,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Creative', range: 430, batteryCapacity: 45 },
          { name: 'Accomplished', range: 502, batteryCapacity: 55 }
        ]
      }
    }
  },
  MG: {
    brandLogo: '/assets/carModelsLogo/MG.png',
    color: '#d41e36',
    models: {
      'ZS EV': {
        id: 'mg-zs-ev',
        name: 'ZS EV',
        image: '/assets/carModelssLogo/mg-zs-ev.png',
        range: 461,
        batteryCapacity: 50.3,
        consumption: 0.109,
        fastChargingPower: 87,
        weight: 1543,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Excite', range: 419, batteryCapacity: 44.5 },
          { name: 'Exclusive', range: 461, batteryCapacity: 50.3 }
        ]
      },
      'Windsor EV': {
        id: 'mg-windsor-ev',
        name: 'Windsor EV',
        image: '/assets/carModelssLogo/mg-windsor-ev.png',
        range: 331,
        batteryCapacity: 38,
        consumption: 0.115,
        fastChargingPower: 45,
        weight: 1348,
        type: 'Hatchback',
        year: '2024',
        variants: [
          { name: 'Base', range: 331, batteryCapacity: 38 }
        ]
      },
      'Comet EV': {
        id: 'mg-comet-ev',
        name: 'Comet EV',
        image: '/assets/carModelssLogo/mg-comet-ev,.png',
        range: 230,
        batteryCapacity: 17.3,
        consumption: 0.075,
        fastChargingPower: 22,
        weight: 865,
        type: 'Hatchback',
        year: '2024',
        variants: [
          { name: 'Base', range: 230, batteryCapacity: 17.3 }
        ]
      }
    }
  },
  BYD: {
    brandLogo: '/assets/carModelsLogo/Byd.png',
    color: '#c41e3a',
    models: {
      'Atto 3': {
        id: 'byd-atto-3',
        name: 'Atto 3',
        image: '/assets/carModelssLogo/byd_atto_3.png',
        range: 521,
        batteryCapacity: 60.48,
        consumption: 0.116,
        fastChargingPower: 88,
        weight: 1750,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Dynamic', range: 468, batteryCapacity: 49.92 },
          { name: 'Premium', range: 521, batteryCapacity: 60.48 }
        ]
      },
      'Seal': {
        id: 'byd-seal',
        name: 'Seal',
        image: '/assets/carModelssLogo/byd-seal.png',
        range: 650,
        batteryCapacity: 82.56,
        consumption: 0.127,
        fastChargingPower: 150,
        weight: 2150,
        type: 'Sedan',
        year: '2024',
        variants: [
          { name: 'Dynamic', range: 510, batteryCapacity: 61.44 },
          { name: 'Premium', range: 650, batteryCapacity: 82.56 }
        ]
      },
      'e6': {
        id: 'byd-e6',
        name: 'e6',
        image: '/assets/carModelssLogo/byd-e6.png',
        range: 415,
        batteryCapacity: 71.7,
        consumption: 0.173,
        fastChargingPower: 80,
        weight: 2235,
        type: 'MPV',
        year: '2024',
        variants: [
          { name: 'GL', range: 415, batteryCapacity: 71.7 }
        ]
      }
    }
  },
  Mahindra: {
    brandLogo: '/assets/carModelsLogo/Mahindra.png',
    color: '#c41e3a',
    models: {
      'XUV400': {
        id: 'mahindra-xuv400',
        name: 'XUV400',
        image: '/assets/carModelssLogo/mahindra_xuv400.png',
        range: 456,
        batteryCapacity: 39.4,
        consumption: 0.086,
        fastChargingPower: 50,
        weight: 1626,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'EC Pro', range: 375, batteryCapacity: 34.5 },
          { name: 'EL Pro', range: 456, batteryCapacity: 39.4 }
        ]
      },
      'BE 6': {
        id: 'mahindra-be6',
        name: 'BE 6',
        image: '/assets/carModelssLogo/mahindra_be6.png',
        range: 682,
        batteryCapacity: 79,
        consumption: 0.116,
        fastChargingPower: 175,
        weight: 2000,
        type: 'SUV',
        year: '2025',
        variants: [
          { name: 'Standard', range: 535, batteryCapacity: 59 },
          { name: 'Extended', range: 682, batteryCapacity: 79 }
        ]
      },
      'XEV 9e': {
        id: 'mahindra-xev9e',
        name: 'XEV 9e',
        image: '/assets/carModelssLogo/mahindra_xev9e.png',
        range: 656,
        batteryCapacity: 79,
        consumption: 0.12,
        fastChargingPower: 175,
        weight: 2100,
        type: 'SUV',
        year: '2025',
        variants: [
          { name: 'Standard', range: 542, batteryCapacity: 59 },
          { name: 'Extended', range: 656, batteryCapacity: 79 }
        ]
      }
    }
  },
  Mercedes: {
    brandLogo: '/assets/carModelsLogo/Mercedes.png',
    color: '#0f1419',
    models: {
      'EQS': {
        id: 'mercedes-eqs',
        name: 'EQS',
        image: '/assets/carModelssLogo/mercedes-eqs.png',
        range: 770,
        batteryCapacity: 107.8,
        consumption: 0.14,
        fastChargingPower: 200,
        weight: 2585,
        type: 'Sedan',
        year: '2024',
        variants: [
          { name: '450+', range: 770, batteryCapacity: 107.8 },
          { name: '580', range: 676, batteryCapacity: 107.8 }
        ]
      }
    }
  },
  Porsche: {
    brandLogo: '/assets/carModelsLogo/Porsche.png',
    color: '#000000',
    models: {
      'Taycan': {
        id: 'porsche-taycan',
        name: 'Taycan',
        image: '/assets/carModelssLogo/porsche-taycan-turbo-s.png',
        range: 557,
        batteryCapacity: 93.4,
        consumption: 0.168,
        fastChargingPower: 270,
        weight: 2295,
        type: 'Sedan',
        year: '2024',
        variants: [
          { name: 'Base', range: 557, batteryCapacity: 93.4 },
          { name: 'Turbo S', range: 440, batteryCapacity: 93.4 }
        ]
      }
    }
  },
  Volvo: {
    brandLogo: '/assets/carModelsLogo/Volvo.png',
    color: '#003057',
    models: {
      'XC40 Recharge': {
        id: 'volvo-xc40',
        name: 'XC40 Recharge',
        image: '/assets/carModelssLogo/volvo-xc40.png',
        range: 418,
        batteryCapacity: 78,
        consumption: 0.187,
        fastChargingPower: 150,
        weight: 2188,
        type: 'SUV',
        year: '2024',
        variants: [
          { name: 'Single Motor', range: 460, batteryCapacity: 69 },
          { name: 'Twin Motor', range: 418, batteryCapacity: 78 }
        ]
      }
    }
  }
};

// Charging strategies matching web app
export const chargingStrategies = [
  {
    id: 'fastest',
    name: 'Fastest Route',
    description: 'Minimize total travel time',
    icon: '⚡',
    color: '#f59e0b'
  },
  {
    id: 'quickest',
    name: 'Quickest Charging',
    description: 'Use fastest chargers available',
    icon: '🚀',
    color: '#10b981'
  },
  {
    id: 'economical',
    name: 'Most Economical',
    description: 'Minimize charging costs',
    icon: '💰',
    color: '#3b82f6'
  },
  {
    id: 'balanced',
    name: 'Balanced',
    description: 'Balance speed and cost',
    icon: '⚖️',
    color: '#8b5cf6'
  }
];

// Amenities for charging stations
export const amenities = [
  { id: 'restroom', name: 'Restroom', icon: '🚻' },
  { id: 'food', name: 'Food & Drink', icon: '🍕' },
  { id: 'shopping', name: 'Shopping', icon: '🛒' },
  { id: 'wifi', name: 'WiFi', icon: '📶' },
  { id: 'parking', name: 'Parking', icon: '🅿️' },
  { id: 'atm', name: 'ATM', icon: '🏧' },
  { id: 'playground', name: 'Playground', icon: '🎮' },
  { id: 'hotel', name: 'Hotel', icon: '🏨' }
];

// Helper function to get all brands
export const getBrands = () => {
  return Object.keys(vehicleDatabase).map(brand => ({
    name: brand,
    logo: vehicleDatabase[brand].brandLogo,
    color: vehicleDatabase[brand].color,
    modelCount: Object.keys(vehicleDatabase[brand].models).length
  }));
};

// Helper function to get models for a brand
export const getModelsForBrand = (brandName) => {
  if (!vehicleDatabase[brandName]) return [];
  
  return Object.values(vehicleDatabase[brandName].models).map(model => ({
    ...model,
    brand: brandName,
    brandColor: vehicleDatabase[brandName].color
  }));
};

// Helper function to get all vehicles in flat array (for backward compatibility)
export const getAllVehicles = () => {
  const vehicles = [];
  Object.keys(vehicleDatabase).forEach(brand => {
    Object.values(vehicleDatabase[brand].models).forEach(model => {
      vehicles.push({
        ...model,
        brand,
        brandColor: vehicleDatabase[brand].color
      });
    });
  });
  return vehicles;
};

// Helper function to find vehicle by ID
export const findVehicleById = (id) => {
  for (const brand of Object.keys(vehicleDatabase)) {
    for (const model of Object.values(vehicleDatabase[brand].models)) {
      if (model.id === id) {
        return {
          ...model,
          brand,
          brandColor: vehicleDatabase[brand].color
        };
      }
    }
  }
  return null;
};